import { isOwnSharedContentItem } from '@littlebird/ui-utils';
import { observer } from 'mobx-react-lite';

import { Text, YStack } from '@/components/ui';
import { useProjectSharedContent } from '@/features/projects/project-shared-content.query';
import { ProjectSharedItemsList } from '@/features/projects/project-shared-items-list';
import { userStore } from '@/stores/user.store';

import { MeetingsProjectEmptyState } from './meetings-empty-state';

// Meeting sync only brings down the user's own meetings, so other members'
// notes in a shared project come from the project's shared-content endpoint.
export const ProjectSliceSharedMeetings = observer(
  function ProjectSliceSharedMeetings({
    projectId,
    hasOwnMeetings,
  }: {
    projectId: string;
    hasOwnMeetings: boolean;
  }) {
    'use no memo';
    const currentUserId = userStore.userId ? Number(userStore.userId) : -1;
    const shared = useProjectSharedContent('meeting', projectId);
    const othersMeetings = shared.data.filter(
      (item) => !isOwnSharedContentItem(item, currentUserId)
    );

    if (othersMeetings.length === 0) {
      if (shared.isLoading || hasOwnMeetings) return null;
      return <MeetingsProjectEmptyState noProject={false} />;
    }

    return (
      <YStack className="gap-3">
        <Text className="text-sm text-foreground-muted px-2">
          From project members
        </Text>
        <ProjectSharedItemsList
          projectId={projectId}
          currentUserId={currentUserId}
          testIdPrefix="meetings-project-shared"
          emptyTitle=""
          emptyDescription=""
          ownHref={(item) => `/meetings/${item.id}`}
          data={othersMeetings}
          isLoading={false}
          hasNextPage={shared.hasNextPage}
          isFetchingNextPage={shared.isFetchingNextPage}
          fetchNextPage={() => void shared.fetchNextPage()}
        />
      </YStack>
    );
  }
);
